import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { provideToastr } from 'ngx-toastr';


import { registerLicense } from '@syncfusion/ej2-base';

// Registering Syncfusion license key
//registerLicense('Ngo9BigBOggjHTQxAR8/V1NHaF5cXmVCf1NpQnxbf1xzZFBMZV9bR39PMyBoS35RdUVqWn9edXFWRWleVkR3'); //Trial license
registerLicense('ORg4AjUWIQA/Gnt2VlhhQlJCfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn9TdkBjUHxacXRXRGNe'); //Community license (full)

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
